import { render } from "./App.vue?vue&type=template&id=3e230db0"
const script = {}

import "./App.vue?vue&type=style&index=0&id=3e230db0&lang=css"

import exportComponent from "../.yarn/__virtual__/vue-loader-virtual-ce2d8e187f/2/root/.yarn/berry/cache/vue-loader-npm-17.4.2-00674d01e5-10c0.zip/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__